<!-- 首页 -->
<template>
  <div>
    <!--<h1>ip ：{{ ip }}</h1>-->
    <van-nav-bar
            title="电影"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
    />
    <!--<div class="head">-->
      <!--&lt;!&ndash;<a href="weixin://dl/business/?appid=wxb825d5efe002861f&path=pages/index/index" @click-left="onClickLeft"> < 返回 </a>&ndash;&gt;-->
      <!--&lt;!&ndash;<a href="" @click-left="onClickLeft" v-if="hasBack==1"> < 返回 </a>&ndash;&gt;-->
      <!--<div class="cityName" @click="toLocation">-->
        <!--<van-icon name="location-o" class="icon"/>{{cityName}}-->
      <!--</div>-->
      <!--<div class="search">-->
        <!--<van-search v-model="form.keyword" class="search-input" placeholder="搜索" @click="toSearch" />-->
<!--&lt;!&ndash;        <newInput v-model="form.keyword"></newInput>&ndash;&gt;-->
      <!--</div>-->
    <!--</div>-->
    <!--<div class="tab">
      <div :class="{active: activeName === 'hot'}" @click="changeTab('hot')">热映</div>
      <div :class="{active: activeName === 'new'}" @click="changeTab('new')">即将上映</div>
    </div>-->

    <div v-if="filmList1.length && activeName === 'hot'">

      <div class="film-list" v-if="filmList1.length && activeName === 'hot'">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getFilesList"
        >
          <div v-for="(item,index) in filmList1" :key="item.id"  class="list-item" @click.stop="toDetail(item)">
            <div class="item-image">
              <van-image
                  fit="aspectFill"
                  :src="`${item.poster}_180x180.jpg`"
              >
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
            </div>
            <div class="item-content">
              <div class="content-text">
                <div class="film-name">{{item.name}}</div>
                <div>观众评分：<span style="color:#FFAA50">{{item.score || '未评分'}}</span></div>
                <div>导演：{{item.director || '未知'}}</div>
                <div>主演：{{item.leadingRole || '未知'}}</div>
              </div>
              <div class="content-btn">
                <van-button type="info" size="nomal" @click.stop="toBuy(item)" style="width:100%">特惠购票</van-button>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <!--<div class="film-list" v-if="filmList2.length && activeName === 'new'">-->
      <!--<van-list-->
          <!--v-model="loading"-->
          <!--:finished="finished"-->
          <!--finished-text="没有更多了"-->
          <!--@load="getFilesList"-->
      <!--&gt;-->
        <!--<div v-for="(item) in filmList2" :key="item.id" class="list-item" @click.stop="toDetail(item)">-->
          <!--<div class="item-image">-->
            <!--<van-image-->
                <!--fit="aspectFill"-->
                <!--:src="item.poster"-->
            <!--&gt;-->
              <!--<template v-slot:loading>-->
                <!--<van-loading type="spinner" size="20" />-->
              <!--</template>-->
            <!--</van-image>-->
          <!--</div>-->
          <!--<div class="item-content">-->
            <!--<div class="content-text">-->
              <!--<div class="film-name">{{item.name}}</div>-->
              <!--<div>观众评分：<span style="color:#FFAA50">{{item.score || '未评分'}}</span></div>-->
              <!--<div>导演：{{item.director || '未知'}}</div>-->
              <!--<div>主演：{{item.leadingRole || '未知'}}</div>-->
            <!--</div>-->
            <!--<div class="content-btn">-->
              <!--<van-button type="info" size="nomal" @click.stop="toDetail(item)" style="width:100%">查看</van-button>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</van-list>-->
    <!--</div>-->

  </div>
</template>

<script>

import axios from "axios";
import {request} from "@/utils/request.js";
import {getMovieList,getCityName,getCityNameByIP } from '@/api/cinema'
import newInput from '@/components/newInput'
export default {
  name: "home",
  components: {newInput},
  props: {},
  data() {
    return {
      ip: '',
      activeName: 'hot',
      form: {
        keyword: '',
        page:1,
        page_size:6
      },
      finished: false,
      loading: false,
      filmList1: [], //热映中电影列表
      filmList2: [], //待上映电影列表
      hasBack: 0 , // hasBack=1 // 是否显示 返回按钮 返回h5 上一页
    }
  },
  methods: {
    onClickLeft(){
      this.$router.back()
    },
    getIp(){
      // https://api.ipify.org/
      // https://ipv4.icanhazip.com/
      axios.get('https://api.ipify.org/').then(res => {
        if (res.data) {
          this.ip = res.data;
          // console.log(res.data, '公网ip')
        }
        else{
          axios.get('https://ipv4.icanhazip.com/').then(res => {
            if (res.data) {
              this.ip = res.data;
              // console.log(res.data, '公网ip')
            }
          }).catch((e) => {
          })
        }
        if(this.ip){
          this.restLocationByIP()
        }
      }).catch((e) => {
        axios.get('https://ipv4.icanhazip.com/').then(res => {
          if (res.data) {
            this.ip = res.data;
            // console.log(res.data, '公网ip')
          }
          if(this.ip){
            this.restLocationByIP()
          }
        }).catch((e) => {
        })
      })
    },

    setCityName(){
      if (!this.$store.state.city.hasMounted) {
        // 逻辑代码...
        let obj = window.SITE_CONFIG['theRequest'];
        if( obj.cityName === undefined || obj.cityName === null || obj.cityName === "" || obj.cityName === 'undefined' ){
          //用坐标查询定位 https://apis.map.qq.com/ws/geocoder/v1/?coord_type=5&get_poi=0&output=json&key=X4RBZ-ZOKWZ-RG3XR-THWDM-ZKQLV-AKFLS&location=24.36799%2C109.3559
        }
        else{ this.$store.state.city.cityName  = decodeURI(obj.cityName);
        }
        this.$store.state.city.hasMounted = true; //只需要转一次码
      }
    },

    setParam(){
        // 逻辑代码...
        let obj = window.SITE_CONFIG['theRequest'];
        if( obj.param === undefined || obj.param === null || obj.param === "" || obj.param === 'undefined' ){}
        else if (!this.$store.state.cinema.param) {
          // this.$store.state.cinema.param  = decodeURI(obj.param);
          this.$store.state.cinema.param  = obj.param;
        }
    },
    // 选择tab
    changeTab(name){
      this.activeName = name
      this.form.page = 1
      this.loading = false
      this.finished = false
      this.filmList1 = []
      this.filmList2 = []
      this.getFilesList()
    },
    // 获取列表
    getFilesList() {
      this.filmList1 = []
      let form = {}
      form.type =  0
      form.page = this.form.page
      form.page_size = this.form.page_size
      form.keyword = this.form.keyword
      form.city_id = this.cityId
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      this.loading = true;
      getMovieList(form).then(res=>{
        // console.log('返回结果为：',res)
        if(res?.data?.list?.length){
          let list = res.data.list || [];
          // if(form.type){
          //   this.filmList2.splice(this.filmList2.length, 0, ...list)
          //   // this.$set(this, 'filmList2', this.filmList2);
          // }else{
          //   this.filmList1.splice(this.filmList1.length, 0, ...list)
          //   // this.$set(this, 'filmList1', this.filmList1);
          // }
          this.filmList1 = list;
          this.filmTotal = res?.data?.total
          // this.finished = list.length < 6;
          this.finished = true //完成 停止轮询内容
        }
        this.form.page ++;
      }).catch(e=>{
        console.log(e)
        if(form.type){
          this.filmList2 = []
        }else{
          this.filmList1 = []
        }
      }).finally(()=>{
        this.loading = false;
        this.$Toast.clear()
      })
    },
    toBuy(item){
      this.$router.push({
        path:'/cinemaList',
        query:{
          movieId:item.movieId,
          cityName:this.$store.state.city.cityName,
          latitude:this.$store.state.city.cityPosition.latitude,
          longitude:this.$store.state.city.cityPosition.longitude,
          cityId:this.cityId
        }
      })
    },
    toDetail(item){
      this.$router.push({
        path:`/filmDetail`,
        query:{
          movieId:item.movieId
        }
      })
    },
    toLocation(){
      this.$router.push({
        path:'/location'
      })
    },
    toSearch(){
      this.$router.push({
        path:'/search'
      })
    },
    // 获取坐标 navigator.geolocation
    getCoordinates(){
      let that = this
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
                (position) => {
                  console.log("Latitude:", position.coords.latitude);
                  console.log("Longitude:", position.coords.longitude);
                  that.$store.state.city.cityPosition = {
                    latitude:position.coords.latitude,
                    longitude:position.coords.longitude,
                  }
                  that.restLocation()
                },
                (error) => {
                  console.error("获取坐标失败:", error);
                });
      }
      else if ("geolocation" in navigator) {
        // 支持 geolocation
        navigator.geolocation.getCurrentPosition(
            (position) => {
              console.log("Latitude:", position.coords.latitude);
              console.log("Longitude:", position.coords.longitude);
              that.$store.state.city.cityPosition = {
                latitude:position.coords.latitude,
                longitude:position.coords.longitude,
              }
              that.restLocation()
            },
            (error) => {
              console.error("获取坐标失败:", error);
            }
        );
      } else {
        console.error("浏览器不支持获取坐标.");
      }
    },
    // 获取坐标 后刷新定位

    // 获取坐标 城市
    restLocation() {
      // console.log('定位开始')
      let lat = this.$store.state.city.cityPosition.latitude;
      let lng = this.$store.state.city.cityPosition.longitude;
      // console.log('定位开始 lat',lat)

      if (!this.$store.state.city.hasMaped && lat > 0) {
        getCityName({
          lat:lat,
          lng:lng,
        }).then(res=>{
          // console.log('返回结果为：',res)
          console.log('坐标定位成功 ', res);
          // let data = ress.data; //获取到所有定位的数据 address_component
          let cityName = res.data.result.address_component.city;
          if (cityName) {
            cityName = cityName.replace(/市/, "");
          }
          console.log('坐标定位成功 当前位置城市：', cityName);
          this.$store.state.city.cityName  = cityName;
          //更新定位
        }).catch(e=>{
          // console.log('catch ')
          // console.log(e)
          let cityName = e.data.result.address_component.city ;

          if (cityName) {
            cityName = cityName.replace(/市/, "");
          }
          console.log('定位成功 当前位置城市 ：', cityName);
          this.$store.state.city.cityName  = cityName;
        }).finally(()=>{
        })
        this.$store.state.city.hasMaped = true; //只需要转一次码
      }
    },
    restLocationByIP() {
      // console.log('定位开始')
      // let lat = this.$store.state.city.cityPosition.latitude;
      // let lng = this.$store.state.city.cityPosition.longitude;
      // console.log('定位开始 lat',lat)

      if (this.ip && !this.$store.state.city.hasIPed ) {
        getCityNameByIP({
          ip:this.ip,
        }).then(res=>{
          // console.log('返回结果为：',res)
          console.log('ip定位成功 ', res);
          // let data = ress.data; //获取到所有定位的数据 address_component
          let cityName = res.data.result.ad_info.city;
          if (cityName) {
            cityName = cityName.replace(/市/, "");
          }
          console.log('ip定位成功 当前位置城市：', cityName);
          this.$store.state.city.cityName  = cityName;
          //更新定位
          this.$store.state.city.cityPosition.latitude = res.data.result.location.lat;
          this.$store.state.city.cityPosition.longitude = res.data.result.location.lng;

        }).catch(e=>{
          // console.log('catch ')
          console.log(e)
        }).finally(()=>{
        })
        this.$store.state.city.hasIPed = true; //只需要转一次码
      }
    },
  },
  created() {
    this.$store.state.cinema.mobile = window.SITE_CONFIG['mobile'];
    this.$store.state.cinema.code = this.$route.query.code ;
    this.form.keyword = this.$route.query.keyword;
    this.hasBack = window.SITE_CONFIG['hasBack'];
    this.getFilesList()
    // this.getCoordinates();
    // this.getIp();
    // this.getIp()
    // this.restLocationByIP()
    //执行过程
    // let _this=this
    // setTimeout(function() {
    //   _this.restLocation()
    // }, 1000)//等待获得坐标后再执行
    // this.restLocation()
  },
  mounted() {
    this.getFilesList()
    this.setCityName()
    this.setParam()
    // this.restLocationByIP()
  },
  computed: {
    cityName(){
      return this.$store.state.city.cityName
    },
    cityId(){
      let id = ''
      if(this.cityList.length && this.cityName){
        this.cityList.map(item=>{
          if(item.cityName === this.cityName){
            id = item.cityCode
          }
        })
      }
      // console.log(id)
      return id
    },
    cityList(){
      return this.$store.state.cinema.cityList
    },
  },
  onLoad() {
    // this.restLocation()
  },
  // watch: {
  //   'form.keyword':{
  //     handler(){
  //       this.form.page = 1
  //       this.loading = false
  //       this.finished = false
  //       this.filmList1 = []
  //       this.filmList2 = []
  //       this.getFilesList()
  //       //搜索影院
  //
  //     }
  //   }
  // }
}
</script>

<style lang="less" scoped>
  .head{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size:28px;
    padding:15px 30px;
    .cityName{
      margin-right:15px;
      background-color: #f7f7f7;
      border-radius: 40px;
      padding: 15px 40px;
      .icon{
        margin-right:10px;
      }
    }
    .search{
      flex:1;
      .search-input{
        font-size:28px;
        input[type='search']{
          font-size:28px!important;
        }
      }
    }

  }

    .tab{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:28px;
    padding:15px 30px;
    margin-top:-25px;
    &>div{
      line-height: 50px;
      &:first-child{
        margin-right:30px;
        border-color: #5EA7E5;
        color:#5EA7E5;
      }
      &:last-child{
        border-color:#E95D32;
        color:#E95D32;
      }

    }
    .active{
      border-bottom:5px solid;
      font-weight: bold;
    }
  }

  .content-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:20px;
    border-top:1px solid #F5F5F5;
    border-bottom:1px solid #F5F5F5;
    &>div {
      &:first-child {
        flex: 0 0 64%;
        margin-right: 4%;
      }

      &:last-child {
        flex: 0 0 32%;
      }
    }
    .head-right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;

      &>view {
        flex: 1 1 auto;

        &:first-child {
          margin-bottom: 20rpx;
        }
      }
    }
    .file-poster0{
      overflow: hidden;
      border-radius: 40px;
    }
    .file-poster1{
      overflow: hidden;
      border-radius: 26px;
      &:first-child{
        margin-bottom:13%;
      }
    }
  }
  .film-list {
    display: block;
    padding:0 20px;
    .list-item {
      padding: 20px 0;
      border-bottom: 1px solid #F5F5F5;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &:last-child{
        border:none;
      }
      .item-image {
        flex: 0 0 170px;
        margin-right: 20px;
        overflow: hidden;
        border-radius: 26px;
      }

      .item-content {
        flex: 1 1 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .content-text {
          flex: 1 1 auto;
          width: 330px;
          color: #A1A2A1;
          font-size: 24px;

          .film-name {
            font-size: 32px;
            color: #000000;
          }

          &>div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 10px 0;
          }

        }

        .content-btn {
          flex: 0 0 170px;
          margin-left: 20px;
        }
      }
    }
  }
</style>
